import React, { useState, useEffect } from 'react';

import './LocationSearch.css';
import FilterBar from './components/FilterBar/FilterBar';
import GlobeMap from './components/GlobeMap/GlobeMap';
import PostDeck from './components/PostDeck/PostDeck';

function App() {
  const [isPostDeckCollapsed, setIsPostDeckCollapsed] = useState(
    JSON.parse(localStorage.getItem("isPostDeckCollapsed")) || false
  );
  const [selectedLocation, setSelectedLocation] = useState(
    JSON.parse(localStorage.getItem("selectedLocation")) || null
  );
 const [fetchedData, setFetchedData] = useState([]); 
  
  useEffect(() => {
    localStorage.setItem("isPostDeckCollapsed", JSON.stringify(isPostDeckCollapsed));
  }, [isPostDeckCollapsed]);
  
  useEffect(() => {
    localStorage.setItem("selectedLocation", JSON.stringify(selectedLocation));
  }, [selectedLocation]);
  


  return (
    <div className="location-app">
      {/* Pass setFetchedData to FilterBar so it can update the data */}
      <FilterBar onLocationSelect={setSelectedLocation} setFetchedData={setFetchedData} />

      <div className="location-main-content">
        {/* Pass fetchedData to GlobeMap to display on the map */}
        <GlobeMap 
          isPostDeckCollapsed={isPostDeckCollapsed} 
          selectedLocation={selectedLocation} 
          fetchedData={fetchedData} // Add fetchedData here
        />
        {/* Pass fetchedData to PostDeck to show posts */}
        <PostDeck 
          fetchedData={fetchedData} // Send the fetched data to PostDeck
          onCollapse={setIsPostDeckCollapsed} 
        />
      </div>
    </div>
  );
}

export default App;
